// extracted by mini-css-extract-plugin
export default {"articles__list":"NewsList_articles__list__o6rmR","list_item":"NewsList_list_item__80Nij","loader":"NewsList_loader__U1LWf","section":"NewsList_section__OQqKc"};